import { render, staticRenderFns } from "./CourseStepsList.vue?vue&type=template&id=911fff58&"
import script from "./CourseStepsList.vue?vue&type=script&lang=js&"
export * from "./CourseStepsList.vue?vue&type=script&lang=js&"
import style0 from "./CourseStepsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
